import React, { createContext, useContext, useMemo } from 'react';

import { useStepper } from '../../common/hooks/useStepper';
import { UPLOAD_TAG_SHEET_STEPS_COUNT } from './constants';
import useUploadTagSheet from './hooks/useUploadTagSheet';
import type { UploadTagSheetContextType, UploadTagSheetStepperProviderProps } from './types';

const UploadTagSheetContext = createContext({} as UploadTagSheetContextType);

export const useUploadTagSheetContext = (): UploadTagSheetContextType => useContext(UploadTagSheetContext);

const UploadTagSheetStepperProvider = ({
  children,
  onCloseStepper,
  selectedCampaigns,
}: UploadTagSheetStepperProviderProps): React.JSX.Element => {
  const { step, goToNextStep, goToPrevStep } = useStepper({
    stepsCount: UPLOAD_TAG_SHEET_STEPS_COUNT,
    onComplete: onCloseStepper,
  });
  const uploadTagSheetData = useUploadTagSheet();

  const value = useMemo(() => {
    return {
      step,
      goToNextStep,
      goToPrevStep,
      onCloseStepper,
      selectedCampaigns,
      ...uploadTagSheetData,
    };
  }, [step, goToNextStep, goToPrevStep, onCloseStepper, selectedCampaigns, uploadTagSheetData]);

  return <UploadTagSheetContext.Provider value={value}>{children}</UploadTagSheetContext.Provider>;
};

export default UploadTagSheetStepperProvider;
